//import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader

import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vuetify.config.silent = true;

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdiSvg',
    },
    materialIcons: false,
    treeShake: true,
    theme: {
        themes: {
            light: {
                primary: '#FF9900',
                secondary: '#b0bec5',
                accent: '#8c9eff',
                error: '#b71c1c',
                grey: '#707070',
            },
        },
    },
});
